import { mapGetters } from 'vuex';
import api from '@checkout/services/api';
import router from "@checkout/router";
import localStorage from "@checkout/services/storage";
import storage from "@checkout/services/storage";
import DisabledStep from "@checkout/components/Partials/DisabledStep.vue";

export default {
    data() {
        return {
            canContinueButton: false,
            mobileTariff: {},
            device: {},
            tVTariff: {},
            tVdevice: [],
            box: {},
            sIM: {},
            other: {},
            bundle: [],
            limit: 0,
            rightSide: {
                oneTime: 0,
                billing: 0,
                total: 0,
            },
            prefix: '/'+ localStorage.get('locale', true),
            skipJumping: false,
            checkoutId: localStorage.get('checkout-id', true)
        };
    },

    components: {
        DisabledStep,
    },

    computed: {
        ...mapGetters(['checkout', 'bundlesCode']),

        binding() {
            if (this.mobileTariff.binding == 182400001 || this.tVTariff.binding == 182400001) {
                return 'x 24 ' + this.$i18nApi.t('months');
            }
            if (this.mobileTariff.binding == 182400002 || this.tVTariff.binding == 182400002) {
                return 'x 1 ' + this.$i18nApi.t('oneMonth');
            }
            if (this.tVTariff.tvDuration) {
                return 'x ' +this.tVTariff.tvDuration + ' ' + this.$i18nApi.t('month');
            }

            return '';
        },
       bindingLang() {
        if (this.mobileTariff.binding == 182400001 || this.tVTariff.binding == 182400001) {
            return '24 ' + this.$i18nApi.t('months') + ' ' + this.$i18nApi.t('za');
        }
        if (this.mobileTariff.binding == 182400002 || this.tVTariff.binding == 182400002) {
            return '1 ' + this.$i18nApi.t('oneMonth') + ' ' + this.$i18nApi.t('za');
        }
        if (this.tVTariff.tvDuration) {
            // return '' + this.tVTariff.tvDuration + ' ' + this.$i18nApi.t('month') + ' ' + this.$i18nApi.t('za');
             return '' + this.tVTariff.tvDuration + ' ' + this.$i18nApi.tc('pluralizedMonts', this.getPluralizeMonthIndex(this.tVTariff.tvDuration), { n: this.tVTariff.tvDuration })  + ' ' + this.$i18nApi.t('za');
        }
        return '';
        },
    },

    methods: {
        prepareStep2() {
            api.get('/public-api/prepare/2/'+ localStorage.get('page-step', true))
                .then(() => this.getData())
                .catch((error) => {
                    this.$swal(this.$i18nApi.t('messages.error'));
                    if (error.response.data.hasOwnProperty('page')) {
                        storage.save('page-step', error.response.data.page, true);
                        this.skipJumping = true;
                        router.push('/checkout/'+ error.response.data.page)
                    } else {
                        router.push('/checkout/1')
                    }
                })
        },
         getPluralizeMonthIndex(duration) {
            const num = duration.toString().substr(duration.toString().length - 1);

            if((num == 1) && !(num == 11)) {
                return 0;
            }
            if ((num == 2 || num == 3 || num == 4) && !(duration == 12 || duration == 13 || duration == 14)){
                return 1;
            }
            if (duration == 11 || duration == 12 || duration == 13 || duration == 14){
                return 2;
            }

            return 2;
        },

        getData() {
            // Get bundle code from vuex
            this.checkout.bundle = this.bundlesCode;
            api.post('/public-api/checkout', this.checkout)
                .then((response) => {
                    response.data.items.forEach(item => {
                        if (Object.keys(item)[0] === 'tVdevice') {
                            this[Object.keys(item)[0]].push(Object.values(item)[0]);
                        } else if (Object.keys(item)[0] === 'bundle') {
                            this[Object.keys(item)[0]].push(Object.values(item)[0]);
                        } else {
                            this[Object.keys(item)[0]] = Object.values(item)[0];
                        }
                    })
                    this.limit = response.data.limit;
                    this.rightSide.oneTime = response.data.oneTime;
                    this.rightSide.billing = response.data.billing;
                    this.rightSide.total = response.data.total;
                    this.canContinueButton = true;
                }).catch(() => {
                this.$swal(this.$i18nApi.t('messages.error'));
            });
        },
    },

    mounted() {
        localStorage.save('page-step', '2', true);

        this.prepareStep2();
    },

    beforeRouteLeave(to, from, next) {
        if (!this.skipJumping && window.location.pathname.split('/').pop() !== undefined) {
            storage.save('page-step', window.location.pathname.split('/').pop(), true);
        }
        next();
    }
}
